/* eslint-disable prettier/prettier */
const footerTableLayout = {
    hLineWidth: function (i, node) {
        return i === 0 ? 1 : 0;
    },
    vLineWidth: function (i) {
        return 0;
    },
    hLineColor: function (i) {
        return i === 1 ? 'black' : '#aaa';
    },
    paddingLeft: function (i) {
        return i === 0 ? 0 : 2;
    },
    paddingRight: function (i, node) {
        return (i === node.table.widths.length - 1) ? 0 : 2;
    },
    paddingTop: function (i, node) {
        if (i === 0) return 7;
        if (i === 5) return 7;
        return 0;
    },
    paddingBottom: function (i, node) {
        return 0;
    }
}

const nestedTableLayout = {
    hLineWidth: function (i, node) {
        return 0;
    },
    vLineWidth: function (i) {
        return 0;
    },
    hLineColor: function (i) {
        return i === 1 ? 'black' : '#aaa';
    },
    paddingLeft: function (i) {
        return i === 0 ? 0 : 2;
    },
    paddingRight: function (i, node) {
        return (i === node.table.widths.length - 1) ? 0 : 2;
    },
    paddingTop: function (i, node) {
        return 0;
    },
    paddingBottom: function (i, node) {
        return 0;
    }
}

const footerFunction = (currentPage, pageCount) => {
    if (currentPage === 1) {
        return {
            table: {
                headerRows: 1,
                widths: [95, 120, 120, 70, 60],
                heights: 7,
                body: [
                    [{ text: 'Vorstand', style: 'tableTextBold' }, { text: 'Rechtsform', style: 'tableTextBold' }, { text: 'Bankverbindung NORD/LB', style: 'tableTextBold' }, { text: 'Hausadresse', style: 'tableTextBold' }, { text: 'Hausverbindung', style: 'tableTextBold' }],
                    [{ text: 'Marc Knackstedt (Vors.)', style: 'tableTextRegular' }, 'Anstalt des öffentlichen Rechts', { text: 'Öffentliche Sachversicherung', style: "tableTextBlue" }, 'Theodor-Heuss-Straße 10', 'T 05 31 / 2 02 - 0'],
                    [{ text: 'Nina Hajetschek', style: 'tableTextRegular' }, { text: 'Öffentliche Sachversicherung Braunschweig', style: "tableTextBlue" }, {
                        table: {
                            widths: [20, 100],
                            body: [
                                ['IBAN', 'DE20 2505 0000 0000 4260 49']
                            ]
                        }, layout: nestedTableLayout, style: 'tableTextRegular'
                    }, '38122 Braunschweig', 'F 05 31 / 2 02 - 15 00'],
                    [{ text: 'Prof. Dr. Alexander Tourneau', style: 'tableTextRegular' }, 'HRA: Braunschweig 8875', {
                        table: {
                            widths: [20, 100],
                            body: [
                                ['BIC', 'NOLADE2HXXX']
                            ]
                        }, layout: nestedTableLayout, style: 'tableTextRegular'
                    }, 'Öffnungszeiten', 'www.oeffentliche.de'],
                    ['', 'Sitz: Braunschweig', {
                        table: {
                            widths: [20, 100],
                            body: [
                                ['GL.-ID.', 'DE74SAC00000082736']
                            ]
                        }, layout: nestedTableLayout, style: 'tableTextRegular'
                    }, 'Mo. - Fr. 8.00 - 18.00', 'service@oeffentliche.de'],
                    [{ colspan: 2, text: 'Vorsitzender des Aufsichtsrats', style: 'tableTextBold' }, '', '', { colSpan: 2, rowSpan: 3, style: 'tableTextGray', text: 'Versicherungsbeiträge sind nach § 4 Nr. 10 UStG\numsatzsteuerfrei. Sach USt-IdNr.: DE 114 87 74 78\nVSt-Nr.: 809/V90809012628' }, ''],
                    [{ colspan: 2, text: 'Dr. Ingo Lippmann' }, '', '', '', ''],
                    [{ colspan: 2, text: 'Vorstandsvorsitzender' }, '', '', '', ''],
                    [{ colspan: 2, text: 'Braunschweigische Landessparkasse' }, '', '', '', ''],
                ]
            },
            layout: footerTableLayout,
            style: 'tableTextRegular',
            margin: [56.75, 31.7, 56.75, 31.7]
        }
    }
}

export { footerFunction }